import Vue from 'vue';

Vue.use(require('vue-pubnub'), {
    subscribeKey: process.env.PUB_SUBSCRIBE_KEY,
    publishKey: process.env.PUB_PUBLISH_KEY,
    logVerbosity: true,
    ssl: true,
    presenceTimeout: 130,
});